<template>
  <el-dialog :title="form.id ? '编辑' : '添加'" :visible.sync="dialogVisible" width="800px" @close="handleClose" :destroy-on-close="true">
    <el-form ref="form" :model="form" label-width="180px">
      <el-form-item label="排序" :required="true" prop="sort">
        <el-input class="input-w" type="number" v-model.number="form.sort" autocomplete="off" placeholder="数值从小到大排序，数值越小越靠前"></el-input>
      </el-form-item>
      <el-form-item label="培训名称" :required="true" prop="name">
        <el-input class="input-w" v-model.trim="form.name" autocomplete="off" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="培训类型" :required="true" prop="type">
        <el-select class="input-w" v-model="form.type" :placeholder="$t('common.pleaseSelect')">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="培训日期" :required="true" prop="businessDate">
        <el-date-picker class="input-w" value-format="yyyy-MM-dd" v-model="form.businessDate" type="date" placeholder="选择日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="时间段" :required="true">
        <template v-for="(item,index) of form.timeData">
          <div class="timeList flex-bet" style="width: 300px; margin-bottom: 10px;" :key="index">
            <el-time-select style="width: 140px;" placeholder="起始时间" v-model="item.startAt" :picker-options="{
            start: '07:00',
            step: '00:15',
            end: '23:59'
            }"></el-time-select>
            <el-time-select style="width: 140px;" placeholder="结束时间" v-model="item.endAt" :picker-options="{
            start: '07:00',
            step: '00:15',
            end: '23:59',
            minTime: item.startAt
            }"></el-time-select>
            <i class="icon el-icon-circle-close" @click="delTime(index)"></i>
          </div>
        </template>
        <el-button type="text" v-if="form.timeData.length < 3" @click="addtime">+添加时间段</el-button>
      </el-form-item>
      <el-form-item label="预约人数上限" :required="true" prop="people">
        <el-input class="input-w" v-model.trim="form.people" autocomplete="off" placeholder="请输入日预约人数上限"></el-input>
      </el-form-item>
      <el-form-item label="联系人" :required="true" prop="linkMan">
        <el-input class="input-w" v-model.trim="form.linkMan" autocomplete="off" placeholder="请输入联系人姓名"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" :required="true" prop="tel">
        <el-input class="input-w" v-model.trim="form.tel" autocomplete="off" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="培训地点" :required="true" prop="address">
        <el-input class="input-w" placeholder="请输入商家地址" v-model="form.address" style="width: 400px">
          <el-button slot="append" @click="searchMapClick">搜索</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="经度" :required="true" prop="lng">
        <el-input class="input-w" v-model.trim="form.lng" autocomplete="off" disabled placeholder="获取中"></el-input>
      </el-form-item>
      <el-form-item label="纬度" :required="true" prop="lat">
        <el-input class="input-w" v-model.trim="form.lat" autocomplete="off" disabled placeholder="获取中..."></el-input>
      </el-form-item>
      <el-form-item label="地图定位" :required="true" prop="tel">
        <select-map ref="mapCom" :mapLng="form.lng" :mapLat="form.lat" :mapAddress="form.address" @clickmap="getMapdata"></select-map>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { trainSave, trainInfo } from '@/api/plugins';
import selectMap from '@/plugins/selectmap';
export default {
  components: {
    selectMap
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        businessDate: this.$moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3)).format('YYYY-MM-DD'),
        name: '',
        timeData: [],
        address: '',
        people: '',
        tel: '',
        sort: 1,
        linkMan: '',
        type: '',
        id: '',
        lng: 118.60994338989,
        lat: 39.2111082131
      }
    };
  },
  methods: {
    // 初始化
    init(id) {
      console.log(id);
      this.dialogVisible = true;
      if (id) {
        this.getTrainInfo(id);
      }
    },
    // 添加时间段
    addtime() {
      if (this.form.timeData.length > 0) {
        const data = this.form.timeData[this.form.timeData.length - 1];
        if (data.startAt && data.endAt) {
          console.log(2);
          const obj = {
            startAt: '',
            endAt: ''
          };
          this.form.timeData.push(obj);
        } else {
          this.$baseMessage('请填写完整起止时间段！', 'warning');
        }
      } else {
        const obj = {
          startAt: '',
          endAt: ''
        };
        this.form.timeData.push(obj);
      }
    },
    // 删除时间段
    delTime(index) {
      this.form.timeData.splice(index, 1);
    },
    // 关闭
    close() {
      this.dialogVisible = false;
      this.$emit('callback');
    },
    // 保存提交数据
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          trainSave(this.form).then((res) => {
            if (res.code == 1) {
              this.$baseMessage(res.msg, 'success');
              this.close();
            }
          });
        }
      });
    },
    // 编辑查看
    getTrainInfo(id) {
      trainInfo({ id: id }).then((res) => {
        if (res.code == 1) {
          console.log(1);
          res.data.lng = res.data.lng ? res.data.lng : 118.60994338989;
          res.data.lat = res.data.lat ? res.data.lat : 39.2111082131;
          this.form = Object.assign(this.form, res.data);
        }
      });
    },
    // 获取地理经纬度和地理名称
    getMapdata(mapAddress, mapLat, mapLng) {
      this.form.address = mapAddress;
      this.form.lat = mapLat;
      this.form.lng = mapLng;
    },
    // 位置搜索
    searchMapClick() {
      this.$refs.mapCom.searchKeyword();
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('callback', false);
    }
  }
};
</script>

<style lang="stylus" scoped>
.timeList {
  position: relative;

  .icon {
    position: absolute;
    font-size: 20px;
    right: -24px;
    top: 50%;
    transform: translateY(-50%);
    color: #DCDFE6;
  }

  .icon:hover {
    color: #ff0000;
  }
}
</style>